import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type {
	LWApiPublicBillingPaymentProfileDetailsParamsRawI,
	LWApiPublicBillingPaymentProfileDetailsResultRawI,
} from '@liquidweb-dev/club-sauce/public/billing/payment/profile.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const BILLING_PAYMENT_PROFILE_DETAILS_QUERY_KEY =
	'/billing/payment/profile/details';

const useBillingPaymentProfileDetails = (
	params: LWApiPublicBillingPaymentProfileDetailsParamsRawI,
	options?: UseQueryOptions<
		LWApiPublicBillingPaymentProfileDetailsResultRawI,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [BILLING_PAYMENT_PROFILE_DETAILS_QUERY_KEY, params],
		queryFn: () => api.billing.payment.profile.apiRaw.details(params),
		...options,
	});

export default useBillingPaymentProfileDetails;
